import React, {CSSProperties, FC} from 'react';
import Box from "../Box";

interface StackProps {
    start: number;
    end: number;
    background: string;
    height?: string;
    width?: string;
    minWidth?: string;
}

const Stack: FC<StackProps> = ({start, end, background, height = 'initial', width = 'initial', minWidth}) => {
    let flex = end - start;

    if (!Number.isFinite(flex)) {
        flex = 0;
    }

    let style: CSSProperties = {
        flex,
        background,
        height,
        width,
        minWidth,
        transition: 'flex 0.5s',
    };

    return <div style={style}/>;
};

interface StacksItem {
    start: number;
    end: number;
    background?: string;
    minWidth?: string;
}

interface StackedBarProps {
    stacks: StacksItem[],
    orientation?: string,
    width?: number,
    height?: string,
    background?: string,
    style: CSSProperties,
    sx: CSSProperties,
}

const StackedBar: FC<StackedBarProps> = (
        {
            stacks,
            orientation = 'horizontal',
            height = 'initial',
            background,
            sx,
            style
        }) => {
    return (
            <Box
                    sx={{
                        display: "flex",
                        flex: 1,
                        ...sx,
                        ...orientation === 'vertical' && {
                            flexDirection: 'column',
                        }
                    }}

                    style={{height, background, ...style}}
            >
                {stacks.map(
                        ({start, end, background, minWidth}, i) => <Stack
                                key={i}
                                start={start}
                                end={end}
                                background={background}
                                minWidth={minWidth}
                        />)}
            </Box>
    );
}

export default StackedBar;
